import { request } from '../request'

// 站点收集数据分析
export const getSiteCollectionAnalyze = () => request('/portal/v1/waf/site_collection/data_analyze')

// 站点收集影响组件筛选列表
export const getComponentFilter = () => request('/portal/v1/waf/site_collection/component_filter')

// 站点收集获取自动更新开关
export const getAutoUpdate = () => request('/portal/v1/waf/site_collection/auto_update')

// 获取站点资源
export const getSiteResource = data => request(`/portal/v1/waf/site/${data.id}`)

export interface GetSiteCollectionList {
  addStatus?: AddStatus
  component?: string
  defenseStatus?: DefenseStatus
  limit?: string
  page?: string
  site?: string
  [property: string]: any
}
export enum AddStatus {
  AddStatusFalse = 'AddStatusFalse',
  AddStatusTrue = 'AddStatusTrue',
  AddStatusUnknown = 'AddStatusUnknown',
}

export enum DefenseStatus {
  WafDefenseStatusProtected = 'WafDefenseStatusProtected',
  WafDefenseStatusUnknown = 'WafDefenseStatusUnknown',
  WafDefenseStatusUnprotected = 'WafDefenseStatusUnprotected',
}
// 站点收集列表
export const getSiteCollectionList = (data: GetSiteCollectionList) =>
  request('/portal/v1/waf/site_collection', {
    params: data,
  })

// 站点收集自动更新开关
export const getSiteCollectionAutoUpdate = data =>
  request('/portal/v1/waf/site_collection/auto_update', {
    method: 'put',
    data,
  })

// 站点收集批量添加站点
export const getSiteCollectionBatchSite = data =>
  request('/portal/v1/waf/site_collection/batch_site', {
    method: 'post',
    data,
  })

// 站点收集增加站点
export const getSiteCollectionAddSite = data =>
  request('/portal/v1/waf/site_collection/site', {
    method: 'post',
    data,
  })
